import { Routes, Route } from 'react-router-dom';

import Header from './header/index.jsx';
import Login from './login.jsx';
// Code-splitting is automated for `pages` directory
import Home from '../pages/home/index.jsx';
import NewFolder from '../pages/NewCustomer/index.jsx';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

const App = () => (
	<div id="app">
		<AuthenticatedTemplate>
		<Header />
		<main>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/NewFolder/:folderType" element={<NewFolder />} />
				<Route path="/login" element={<Login />} />
			</Routes>
		</main>

		</AuthenticatedTemplate>

    <UnauthenticatedTemplate>
    <Login />
    </UnauthenticatedTemplate>


	</div>

);

export default App;

